import { Spin } from 'antd';
import download from 'downloadjs';
import React, { ReactNode, useState } from 'react';
import { HiOutlineLightBulb } from 'react-icons/hi';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Apis from '../../../api';
import Logo from '../../../assets/images/onboardingLogo.svg';
import { HEADERMENU_PATH } from '../../../routes/RoutesURL';
import { RootState } from '../../../store/rootReducer';
import HSButton from '../../common/Button';
import AccountDropdown from '../onboarding/components/common/AccountDropdown';
import OnboardingRightContainer from '../onboarding/components/common/Container';
import InfoPOP from '../onboarding/components/common/InfoPop';
import { DownloadButton } from '../onboarding/components/nda';
import { AgreementTypes } from '../settings/fragments/Agreements';

const PostAgreements: React.FC = () => {
    const navigate = useNavigate();
    const [loader, setLoader] = useState<string[]>([]);
    const [open, setOpen] = useState(false);
    const isHIPLUser = useSelector((state: RootState) => state.user.investor?.isHIPL);
    const investorUUID = useSelector((state: RootState) => state.user.investor?.uuid);
    const agreements = useSelector((state: RootState) => state.user.investor?.agreements);
    const investorType = useSelector((state: RootState) => state.user.investor?.investorType);

    //const reviewsV2 = useSelector((state: RootState) => state.user.investor?.kyc?.reviewsV2);
    //const HIPL_KYC = reviewsV2?.find((r) => r.entity === 'HIPL');
    //const HIPL_KYC_Status = HIPL_KYC?.status;

    const AIConsent = agreements?.find((a) => a.agreementType === 'AIConsent');
    const aiVenue = AIConsent?.venue;
    const aiStatus = AIConsent?.status;
    const aiAgreementUUID = AIConsent?.uuid;

    const HIPLAIConsent = agreements?.find((a) => a.agreementType === 'HIPL AI Consent');
    const HIPLAiVenue = HIPLAIConsent?.venue;
    const HIPLAiStatus = HIPLAIConsent?.status;
    const HIPLAgreementUUID = HIPLAIConsent?.uuid;

    const SubscriptionAgreement = agreements?.find((a) => a.agreementType === 'SubscriptionAgreement');
    const subVenue = SubscriptionAgreement?.venue;
    const subStatus = SubscriptionAgreement?.status;
    const subAgreementUUID = SubscriptionAgreement?.uuid;

    const downloadFile = (type: string, agreementUUID?: string) => {
        if (investorUUID && agreementUUID) {
            let arr = [...loader];
            const index = arr.indexOf(type);
            if (index === -1) {
                arr.push(type);
            }
            setLoader(arr);
            Apis.downloadFile(investorUUID, agreementUUID)
                .then((res) => {
                    download(new Blob([res.data]), `${type}.pdf`, 'application/pdf');
                })
                .finally(() => {
                    let arr = [...loader];
                    const index = arr.indexOf(type);
                    if (index !== -1) {
                        arr.splice(index, 1);
                    }
                    setLoader(arr);
                });
        }
    };

    return (
        <RequiredLayout>
            <InfoPOP
                open={open}
                setOpen={setOpen}
                icon={<HiOutlineLightBulb size={'1.8rem'} color="#1b3e8c" />}
                text={`<div>
                      <p className="text-sm WorkSans font-bold text-color-404040">AI Consent</p>
                      <p>MAS implemented legislative amendments to enhance regulatory safeguards for investors in 2018. The criteria for an investor to qualify as an Accredited Investor had been refined, and MAS introduced an opt-in regime for investors electing for Accredited Investor status. As our platform can only serve Accredited Investors, this AI consent is required to be provided from our investors.</p>
                      <p className="text-sm WorkSans font-bold text-color-404040 pt-5">Subscription agreement</p>
                      <p>The Subscription Agreement contains the general terms for the use of the platform.</p>
                    </div>`}
            />
            <div>
                <p className="text-color-404040  text-center text-xl WorkSans-Semibold pb-4">
                    Please sign post accreditation
                </p>
                <div
                    className="flex items-center justify-end cursor-pointer pb-2 font-[Lato]"
                    onClick={() => setOpen(true)}
                >
                    <HiOutlineLightBulb size={'1.25rem'} color="#1b3e8c" />{' '}
                    <p className="text-sm">Why are we requesting these?</p>
                </div>
                {investorType !== 'Institutional' ? (
                    <>
                        <p className="page_title_onboarding mt-3">AI Consent</p>
                        <div className="w-full py-2 bg-white mt-3  px-4 rounded-lg flex justify-center items-center">
                            {AIConsent && (
                                <div className="flex items-center text-base">
                                    <div className="flex justify-center items-center">
                                        {aiStatus !== 'Skipped' ? `Signed` : 'Skipped'}
                                        {aiStatus !== 'Skipped' && <b>&nbsp;{aiVenue}</b>}
                                        {aiStatus === 'Completed' &&
                                            loader.indexOf(AgreementTypes.AIConsent) === -1 && (
                                                <DownloadButton
                                                    onClick={() =>
                                                        downloadFile(AgreementTypes.AIConsent, aiAgreementUUID)
                                                    }
                                                />
                                            )}
                                        {loader.indexOf(AgreementTypes.AIConsent) !== -1 && (
                                            <Spin className="ml-1 h-7 w-8 flex justify-center items-center" />
                                        )}
                                    </div>
                                </div>
                            )}
                            {!AIConsent && (
                                <HSButton
                                    type="link"
                                    className="w-full"
                                    title="Sign Agreement"
                                    onClick={() => navigate(HEADERMENU_PATH.signAIConsent)}
                                />
                            )}
                        </div>
                    </>
                ) : null}
                <p className="page_title_onboarding mt-6">Subscription Agreement</p>
                <div className="w-full py-2 bg-white mt-3 px-4 rounded-lg flex justify-center items-center">
                    {SubscriptionAgreement && (
                        <div className="flex items-center text-base">
                            <div className="flex justify-center items-center">
                                {subStatus !== 'Skipped' ? `Signed` : 'Skipped'}
                                {subStatus !== 'Skipped' && <b>&nbsp;{subVenue}</b>}

                                {subStatus === 'Completed' &&
                                    loader.indexOf(AgreementTypes.SubscriptionAgreement) === -1 && (
                                        <DownloadButton
                                            onClick={() =>
                                                downloadFile(AgreementTypes.SubscriptionAgreement, subAgreementUUID)
                                            }
                                        />
                                    )}
                                {loader.indexOf(AgreementTypes.SubscriptionAgreement) !== -1 && (
                                    <Spin className="ml-1 h-7 w-8 flex justify-center items-center" />
                                )}
                            </div>
                        </div>
                    )}
                    {!SubscriptionAgreement && (
                        <HSButton
                            type="link"
                            title="Sign Agreement"
                            className="w-full"
                            onClick={() => navigate(HEADERMENU_PATH.signSubscription)}
                        />
                    )}
                </div>
                {isHIPLUser && (
                    <>
                        <p className="page_title_onboarding mt-6">HIPL AI Consent</p>
                        <div className="w-full py-2 bg-white mt-3 px-4 rounded-lg flex justify-center items-center">
                            {HIPLAIConsent && (
                                <div className="flex items-center text-base">
                                    <div className="flex justify-center items-center">
                                        {HIPLAiStatus !== 'Skipped' ? `Signed` : 'Skipped'}
                                        {HIPLAiStatus !== 'Skipped' && <b>&nbsp;{HIPLAiVenue}</b>}

                                        {HIPLAiStatus === 'Completed' &&
                                            loader.indexOf(AgreementTypes.HIPLAIConsent) === -1 && (
                                                <DownloadButton
                                                    onClick={() =>
                                                        downloadFile(AgreementTypes.HIPLAIConsent, HIPLAgreementUUID)
                                                    }
                                                />
                                            )}
                                        {loader.indexOf(AgreementTypes.HIPLAIConsent) !== -1 && (
                                            <Spin className="ml-1 h-7 w-8 flex justify-center items-center" />
                                        )}
                                    </div>
                                </div>
                            )}
                            {!HIPLAIConsent && (
                                <HSButton
                                    type="link"
                                    title="Sign Agreement"
                                    className="w-full"
                                    onClick={() => navigate(HEADERMENU_PATH.signHIPLAIConsent)}
                                />
                            )}
                        </div>
                    </>
                )}
            </div>
        </RequiredLayout>
    );
};

export default PostAgreements;

type Props = {
    children: ReactNode;
};

export const RequiredLayout: React.FC<Props> = ({ children }) => {
    return (
        <div id="onboarding" className="w-full px-4 h-full">
            <div className="py-2 pt-0 flex justify-between items-center" style={{ height: 80 }}>
                <img src={Logo} alt="logoImage" />
                <AccountDropdown />
            </div>
            <OnboardingRightContainer>{children}</OnboardingRightContainer>
        </div>
    );
};
